// =============================================
//         BASE
// =============================================

import { ButtonTopicItemTypes } from './contentful.types';

// =============================================
export type PagePropTypes = {
  params: Promise<{
    slug: string;
    locale: string;
  }>;
};

export type CarouselCardsTypes = {
  buttons: ButtonTopicItemTypes[];
  icon: string;
  pretitle: string;
  url: string;
  clinicTitle?: string;
  title: string;
  description?: string | React.ReactNode;
  carouselRef?: React.Ref<HTMLDivElement>;
};

export enum TailwindBreakPoints {
  xsm = 425,
  sm = 500,
  md = 768,
  lg = 1024,
  xl = 1280,
  _2xl = 1444,
  _3xl = 1536,
  _4xl = 1632,
}

// =============================================
//         SESSION STORAGE TYPES
// =============================================
export type SessionStorageKeyTypes = 'categoryFilters';
export type SessionStorageValueTypes = any; // Add more types

export type GetSessionStorageParamTypes = {
  key: SessionStorageKeyTypes;
  defaultValue: SessionStorageValueTypes;
};

export type SessionStorageParamTypes = {
  key: SessionStorageKeyTypes;
  value: SessionStorageValueTypes;
};

export type GetSessionStorageReturnTypes = any;

// =============================================
//                   CSS TYPES
// =============================================
export type ObjectFitTypes = 'fill' | 'contain' | 'cover' | 'none' | 'scale-down';
